import { createFileRoute } from "@tanstack/react-router";
import { RepresentativesSetupPage } from "@/components/representative/RepresentativesSetupPage";
import { DICTS } from "@/lib/i18n";
import { SiteShell } from "@/components/SiteShell";

export const Route = createFileRoute("/admin/representatives")({
  ssr: false,
  component: () => <SiteShell><RepresentativesSetupPage /></SiteShell>,
  head: () => ({
    meta: [
      { title: `${DICTS.en["representative.admin"]} · Lecmo Admin` },
      { name: "description", content: DICTS.en["representative.admin.description"] },
      { property: "og:title", content: `${DICTS.en["representative.admin"]} · Lecmo Admin` },
      { property: "og:description", content: DICTS.en["representative.admin.description"] },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
